import React, { useState } from "react";
import Bank from "../components/Bank/Bank";
import { useAuth } from "../hooks/AuthContext";
import { useNavigation } from '../hooks/useNavigation';
import Layout from "../Layout/Layout";

const BankContainer = () => {
  const { logout } = useAuth();
  const navigation = useNavigation();
  const [selectedBank, setSelectedBank] = useState(null);

  const handleBankSelect = (bank) => {
    setSelectedBank(bank);
  };

  const tutorials = {
    itau: [
      "Clique no seu nome de usuário:",
      'Selecione a opção "Mais opções":',
      'Selecione o item "Preferência de comunicação":',
      'Ativar a opção de mensagens de SMS e clique em "Editar dados":',
      'Escolha a modalidade "telefone":',
      'Edite com o número da Vempix e clique em "Continuar":',
      "Pronto, seu banco está conectado com a Vempix!",
    ],
    nubank: ["Em breve!"],
  };

  return (
    <Layout
      logout={logout}
      {...navigation}
    >
      <Bank
        selectedBank={selectedBank}
        onBankSelect={handleBankSelect}
        tutorials={tutorials}
      />
    </Layout>
  );
};

export default BankContainer;

